
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as testxsY6W0_J7j9mJtOr3DTRhPMaO2aIyZuVN7WqGunxWMgMeta } from "/codebuild/output/src1569322956/src/repo/pages/test.vue?macro=true";
import { default as teamsKZW3ddEWfe73ZuuE6NDUpz_45cGCPFjwLx8qMBY6KbGvYMeta } from "/codebuild/output/src1569322956/src/repo/pages/admin/teams.vue?macro=true";
import { default as employeesbAlD_4552Mprglj8vn_v_455n198l1FnC_45WgN8xZtAtYmDkMeta } from "/codebuild/output/src1569322956/src/repo/pages/admin/employees.vue?macro=true";
import { default as adminn5QdHxVPLQmaryyNRTq_7aOQ4gwv6HQf3hgKDcELw6EMeta } from "/codebuild/output/src1569322956/src/repo/pages/admin.vue?macro=true";
import { default as indexvLJYET8zHl6I93bb9QP822VR4ZjqUnNXJdvBKquER1EMeta } from "/codebuild/output/src1569322956/src/repo/pages/index.vue?macro=true";
import { default as login_05MHgngKxYlq4HwDYJXvIIRnkcE43Ib3NLJoyVb_X4Meta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/login.vue?macro=true";
import { default as verifyR3OYWF3ICJD_Q0363FtUN2_ZfXbMOoUuRla0AMwFPCsMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/verify.vue?macro=true";
import { default as registerWoHVrhttvbZ8kihfvIjZLejwIoGiUzHJ4Cwlgx9tm_oMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/register.vue?macro=true";
import { default as showcase8xbt_PtH9xMUe8xkfspfEfmUdtfBBi1ZxpwNwEGKKnEMeta } from "/codebuild/output/src1569322956/src/repo/pages/showcase.vue?macro=true";
import { default as onboardingphyESyh_fwtbMUFqALNVkf_jbI7AW3cIVZ6eXHmevToMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/onboarding.vue?macro=true";
import { default as indexpGLStVYOLVQAqnqL_uQASPO61igbIVUf_DH_pt5bDhwMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/account-setup/index.vue?macro=true";
import { default as verifyU3vCHoE2Re09OZdZ3ilrcxNYFipZwwyO4q_45MYNFgz8IMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/account-setup/verify.vue?macro=true";
import { default as code_45expirejcXjlYtiiSnglHsTxSzEONtvw3_SCchcM2p1aInvZtYMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/account-setup/code-expire.vue?macro=true";
import { default as create_45passworddcdkT9DIQf4zH74jKAo8DAerO8mtzzZUTwuFdl_lbOcMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/account-setup/create-password.vue?macro=true";
import { default as account_45setup_452z81NG1UrB_eREGd1PQAakK6gb2_Z01ByADxGK3gU8Meta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/account-setup.vue?macro=true";
import { default as aboutPRDVX4lxT6LJhyqYmi6eY2ukE5KW5UG3pAeMg6WJtcQMeta } from "/codebuild/output/src1569322956/src/repo/pages/account/about.vue?macro=true";
import { default as indexmtDAvNbetW_456ZFnlG00wPrY8h1IXL9z1JQNbLanfOskMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/account/index.vue?macro=true";
import { default as privacy_45policyuB_rD8aldWe5hSuXqAWKsBySf3QOcWR4xe59YhU1_45noMeta } from "/codebuild/output/src1569322956/src/repo/pages/privacy-policy.vue?macro=true";
import { default as reset_45passwordRdmLRximq3sRhAqxRDn568HyHKCBLc536YTOA07ZubwMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/reset-password.vue?macro=true";
import { default as terms_45of_45serviceLLyQzyVfGr1KhbpqLtKpIOl1zRr8q08CEOgkySbwq10Meta } from "/codebuild/output/src1569322956/src/repo/pages/terms-of-service.vue?macro=true";
import { default as company_45wellbeingJQ0tH408mILY3ZPqnYHOBNMqDgQQjeX_451p4QuP5YFv4Meta } from "/codebuild/output/src1569322956/src/repo/pages/company-wellbeing.vue?macro=true";
import { default as company_45profile_lEUzwCO2W_DzUGWZyvR5MaXvMv7KvJLhmFvJof2HAsMeta } from "/codebuild/output/src1569322956/src/repo/pages/account/company-profile.vue?macro=true";
import { default as personal_45detailsdXTs0hGoUA4QuIfwESV1jOaVyYCGYMdZRijRTNReJosMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/account/personal-details.vue?macro=true";
import { default as indexa4Z0NfdoAORqXZsAcp_Ql_oUsTBVV2pX_Ca_455LnbSjUMeta } from "/codebuild/output/src1569322956/src/repo/pages/account/help-centre/index.vue?macro=true";
import { default as indexmXN1fwilO59f1bTGO3rbrzmGXpiGHm8pC_VtJbmXmnQMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/account/account-settings/index.vue?macro=true";
import { default as report_45a_45problemfGbS7GRn_45KJ2vpqsMFB2s7ngO3i7js8shv_CyGwZzOwMeta } from "/codebuild/output/src1569322956/src/repo/pages/account/help-centre/report-a-problem.vue?macro=true";
import { default as delete_45accountdg6GA4UTfUY2sVcF9SkAEqxd_45mwwEDXHMWsvqjzDX2UMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/account/account-settings/delete-account.vue?macro=true";
import { default as update_45passwordmAHSHESYBEMsNxh_4587ciqWY54kS_45AmjZCUlwdyE5DvsMeta } from "/codebuild/output/src1569322956/src/repo/modules/auth/pages/account/account-settings/update-password.vue?macro=true";
export default [
  {
    name: "test",
    path: "/test",
    meta: testxsY6W0_J7j9mJtOr3DTRhPMaO2aIyZuVN7WqGunxWMgMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/test.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/admin.vue"),
    children: [
  {
    name: "admin-teams",
    path: "teams",
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/admin/teams.vue")
  },
  {
    name: "admin-employees",
    path: "employees",
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/admin/employees.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexvLJYET8zHl6I93bb9QP822VR4ZjqUnNXJdvBKquER1EMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login_05MHgngKxYlq4HwDYJXvIIRnkcE43Ib3NLJoyVb_X4Meta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/login.vue")
  },
  {
    name: "verify",
    path: "/verify",
    meta: verifyR3OYWF3ICJD_Q0363FtUN2_ZfXbMOoUuRla0AMwFPCsMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/verify.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerWoHVrhttvbZ8kihfvIjZLejwIoGiUzHJ4Cwlgx9tm_oMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/register.vue")
  },
  {
    name: "showcase",
    path: "/showcase",
    meta: showcase8xbt_PtH9xMUe8xkfspfEfmUdtfBBi1ZxpwNwEGKKnEMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/showcase.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingphyESyh_fwtbMUFqALNVkf_jbI7AW3cIVZ6eXHmevToMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/onboarding.vue")
  },
  {
    name: account_45setup_452z81NG1UrB_eREGd1PQAakK6gb2_Z01ByADxGK3gU8Meta?.name,
    path: "/account-setup",
    meta: account_45setup_452z81NG1UrB_eREGd1PQAakK6gb2_Z01ByADxGK3gU8Meta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/account-setup.vue"),
    children: [
  {
    name: "account-setup",
    path: "",
    meta: indexpGLStVYOLVQAqnqL_uQASPO61igbIVUf_DH_pt5bDhwMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/account-setup/index.vue")
  },
  {
    name: "account-setup-verify",
    path: "verify",
    meta: verifyU3vCHoE2Re09OZdZ3ilrcxNYFipZwwyO4q_45MYNFgz8IMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/account-setup/verify.vue")
  },
  {
    name: "account-setup-code-expire",
    path: "code-expire",
    meta: code_45expirejcXjlYtiiSnglHsTxSzEONtvw3_SCchcM2p1aInvZtYMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/account-setup/code-expire.vue")
  },
  {
    name: "account-setup-create-password",
    path: "create-password",
    meta: create_45passworddcdkT9DIQf4zH74jKAo8DAerO8mtzzZUTwuFdl_lbOcMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/account-setup/create-password.vue")
  }
]
  },
  {
    name: "account-about",
    path: "/account/about",
    meta: aboutPRDVX4lxT6LJhyqYmi6eY2ukE5KW5UG3pAeMg6WJtcQMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/account/about.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexmtDAvNbetW_456ZFnlG00wPrY8h1IXL9z1JQNbLanfOskMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/account/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyuB_rD8aldWe5hSuXqAWKsBySf3QOcWR4xe59YhU1_45noMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/privacy-policy.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordRdmLRximq3sRhAqxRDn568HyHKCBLc536YTOA07ZubwMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/reset-password.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    meta: terms_45of_45serviceLLyQzyVfGr1KhbpqLtKpIOl1zRr8q08CEOgkySbwq10Meta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/terms-of-service.vue")
  },
  {
    name: "company-wellbeing",
    path: "/company-wellbeing",
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/company-wellbeing.vue")
  },
  {
    name: "account-company-profile",
    path: "/account/company-profile",
    meta: company_45profile_lEUzwCO2W_DzUGWZyvR5MaXvMv7KvJLhmFvJof2HAsMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/account/company-profile.vue")
  },
  {
    name: "account-personal-details",
    path: "/account/personal-details",
    meta: personal_45detailsdXTs0hGoUA4QuIfwESV1jOaVyYCGYMdZRijRTNReJosMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/account/personal-details.vue")
  },
  {
    name: "account-help-centre",
    path: "/account/help-centre",
    meta: indexa4Z0NfdoAORqXZsAcp_Ql_oUsTBVV2pX_Ca_455LnbSjUMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/account/help-centre/index.vue")
  },
  {
    name: "account-account-settings",
    path: "/account/account-settings",
    meta: indexmXN1fwilO59f1bTGO3rbrzmGXpiGHm8pC_VtJbmXmnQMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/account/account-settings/index.vue")
  },
  {
    name: "account-help-centre-report-a-problem",
    path: "/account/help-centre/report-a-problem",
    meta: report_45a_45problemfGbS7GRn_45KJ2vpqsMFB2s7ngO3i7js8shv_CyGwZzOwMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/pages/account/help-centre/report-a-problem.vue")
  },
  {
    name: "account-account-settings-delete-account",
    path: "/account/account-settings/delete-account",
    meta: delete_45accountdg6GA4UTfUY2sVcF9SkAEqxd_45mwwEDXHMWsvqjzDX2UMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/account/account-settings/delete-account.vue")
  },
  {
    name: "account-account-settings-update-password",
    path: "/account/account-settings/update-password",
    meta: update_45passwordmAHSHESYBEMsNxh_4587ciqWY54kS_45AmjZCUlwdyE5DvsMeta || {},
    component: () => import("/codebuild/output/src1569322956/src/repo/modules/auth/pages/account/account-settings/update-password.vue")
  }
]